import ContainerHideNavScroll from "../../../Components/PageLayout/HideNavScroll/HideNavScroll"

const HideNavScroll = () => {
  return (
    <div className='page-body'>
      <ContainerHideNavScroll />
    </div>
  )
}

export default HideNavScroll